import { useTheme } from '../../ThemeContext';

export default function ModalShell({
  children,
  onClose,
  maxWidth = '500px',
  blur = false,
  scrollable = false,
  zIndex = 1000,
  panelStyle = {},
}) {
  const { t } = useTheme();

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: t.overlayBg,
        ...(blur ? { backdropFilter: 'blur(4px)' } : {}),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex,
      }}
      onClick={onClose || undefined}
    >
      <div
        style={{
          backgroundColor: t.surface,
          padding: '32px',
          borderRadius: '12px',
          maxWidth,
          width: '90%',
          position: 'relative',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          ...(scrollable ? { maxHeight: '90vh', overflowY: 'auto' } : {}),
          ...panelStyle,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
